module.exports = __webpack_public_path__ + "img/redeem-10k.b6227a8d.png";